import { get as _get } from 'lodash';
import { webmasterConstants } from '../constants/webmaster';
import { setMessages } from './alerts';
import { webmaster, offers, tickets, dashboard } from '../services/ApiService';

// const getTheme = (getState, profile) => {
//   const theme = _get(profile, 'theme');
//   const themes = _get(getState().app, 'globalSettings.themes');

//   if (theme === 0) return 0;

//   if (theme && themes) {
//     if (themes.find(item => item.id === theme)) {
//       return theme;
//     }
//     return 1;
//   }
//   return 1;
// };

export const initialization = () => ({
  type: webmasterConstants.SET_DYNAMIC_DATA,
});

export const logout = () => ({ type: webmasterConstants.LOGOUT });

export const startLogout = () => dispatch => {
  dispatch({ type: webmasterConstants.START_LOGOUT });
  return webmaster.logout().then(() => dispatch(logout()));
};

export const login = ({ messages, ...profile }) => (dispatch, getState) => {
  dispatch(setMessages(messages));
  return dispatch({
    type: webmasterConstants.LOGIN_SUCCESS,
    profile: {
      ...profile,
      // theme: getTheme(getState, profile),
    },
  });
};

export const setProfile = (prof = {}, params = {}) => (dispatch, getState) => {
  const { messages, ...profile } = prof;
  dispatch(setMessages(messages));
  return dispatch({
    type: webmasterConstants.LOGIN_SUCCESS,
    profile: {
      ...profile,
      // theme: getTheme(getState, profile),
    },
    ...params,
  });
};

export const startSetProfile = params => dispatch => {
  return webmaster
    .getBasicInfo()
    .then((data = {}) => dispatch(setProfile(data.items, params)))
    .catch(err => dispatch({ type: webmasterConstants.LOGIN_FAILURE }));
};

export const startSetEditProfile = data => dispatch => {
  return webmaster
    .setBasicInfo(data)
    .then(data => dispatch({ type: webmasterConstants.EDIT_PROFILE_SUCCESS, data }));
  // .catch(err => dispatch({ type: webmasterConstants.EDIT_PROFILE_FAILURE, err }));
};

export const setBalance = balance => ({
  type: webmasterConstants.SET_BALANCE_SUCCESS,
  balance,
});

export const startSetBalance = () => dispatch => {
  return webmaster
    .getBalance()
    .then((data = {}) => dispatch(setBalance(data.items)))
    .catch(err => dispatch({ type: webmasterConstants.SET_BALANCE_FAILURE }));
};

export const setManager = manager => ({
  type: webmasterConstants.SET_MANAGER_SUCCESS,
  manager,
});

export const startSetManager = () => dispatch => {
  return webmaster
    .getManager()
    .then((data = { items: [] }) => dispatch(setManager(data.items[0])))
    .catch(err => dispatch({ type: webmasterConstants.SET_MANAGER_FAILURE }));
};

export const changePassword = result => ({
  type: webmasterConstants.SET_PASSWORD_SUCCESS,
  result,
});

export const otherSessions = result => ({
  type: webmasterConstants.END_OTHER_SESSIONS,
  result,
});

export const startChangePassword = passwords => dispatch => {
  return webmaster
    .changePassword(passwords)
    .then((data = {}) => dispatch(changePassword(data.items)))
    .catch(({ response = {} }) =>
      dispatch({
        type: webmasterConstants.SET_PASSWORD_FAILURE,
        error: response.data.error.message,
      }),
    );
};

export const endOtherSessions = () => dispatch => {
  return webmaster
    .endOtherSessions()
    .then((data = {}) => dispatch(otherSessions(data)))
    .catch(({ response = {} }) =>
      dispatch({
        type: webmasterConstants.OTHER_SESSIONS_FAILURE,
        error: response.data.error.message,
      }),
    );
};

export const setNotify = notifications => ({
  type: webmasterConstants.SET_NOTIFY_SUCCESS,
  notifications,
});

export const startSetNotify = () => dispatch => {
  return webmaster
    .getNotify()
    .then((data = {}) => dispatch(setNotify(data.items)))
    .catch(({ response = {} }) =>
      dispatch({
        type: webmasterConstants.SET_NOTIFY_SUCCESS,
        error: response.data.error.message,
      }),
    );
};

export const editNotify = notifications => {
  return {
    type: webmasterConstants.EDIT_NOTIFY_SUCCESS,
    notifications,
  };
};

export const startEditNotify = notifications => dispatch => {
  return webmaster
    .editNotify(notifications)
    .then((data = {}) => dispatch(editNotify(data.items)))
    .catch(({ response = {} }) =>
      dispatch({
        type: webmasterConstants.EDIT_NOTIFY_FAILURE,
        error: response.data.error.message,
      }),
    );
};

export const setMyOffers = (offers = []) => ({
  type: webmasterConstants.SET_OFFERS_LIST_SUCCESS,
  offers,
});

export const startSetMyOffers = (params = {}) => dispatch => {
  return offers
    .getList({ tab: 'my', ...params })
    .then((data = {}) => dispatch(setMyOffers(data.items)))
    .catch(err => dispatch({ type: webmasterConstants.SET_OFFERS_LIST_FAILURE }));
};

export const startRequestOfferAccess = offerId => dispatch =>
  webmaster.requestOffer(offerId).then(() => dispatch(requestOfferAccess(offerId)));

export const requestOfferAccess = offerId => ({
  type: webmasterConstants.OFFER_REQUEST_SUCCESS,
  offerId,
});

export const refuseOfferAccess = offerId => ({
  type: webmasterConstants.OFFER_REFUSE_SUCCESS,
  offerId,
});

export const startRefuseOfferAccess = offerId => dispatch =>
  webmaster.refuseOffer(offerId).then(() => dispatch(refuseOfferAccess(offerId)));

export const startConfirmPhone = data => dispatch => {
  return webmaster.confirmPhone(data).then(response => {
    dispatch({ type: webmasterConstants.CONFIRM_PHONE_PROFILE_SUCCESS });
    return response;
  });
};

export const setDashboardSettings = settings => ({
  type: webmasterConstants.SET_DASHBOARD_SETTINGS_SUCCESS,
  settings,
});

export const startSetDashboardSettings = (settings = {}) => dispatch => {
  return dashboard
    .getSettings()
    .then((data = { items: [] }) => dispatch(setDashboardSettings(data.items[0])));
};

export const startUpdateDashboardSettings = settings => dispatch => {
  dispatch(setDashboardSettings(settings));
  const payload = { data: JSON.stringify(settings) };

  return dashboard.updateSettings(payload).then(() => {
    console.log('saved');
  });
};

export const setUnreadTicketsCount = ({ count = 0 }) => ({
  type: webmasterConstants.SET_UNREAD_TICKETS_SUCCESS,
  count,
});

export const startSetUnreadTicketsCount = () => dispatch => {
  return tickets
    .getUnreadCount()
    .then((data = { items: [] }) => dispatch(setUnreadTicketsCount(data.items[0])))
    .catch(e => dispatch({ type: webmasterConstants.SET_UNREAD_TICKETS_FAILURE }));
};

export const removeSocialAccount = accountId => ({
  type: webmasterConstants.REMOVE_SOCIAL_ACCOUNT_SUCCESS,
  accountId,
});

export const startRemoveSocialAccount = accountId => dispatch =>
  webmaster
    .removeSocialAccount(accountId)
    .then(data => dispatch(removeSocialAccount(accountId)))
    .catch(e => dispatch({ type: webmasterConstants.REMOVE_SOCIAL_ACCOUNT_FAILURE }));

export const setSocialAccount = account => ({
  type: webmasterConstants.SET_SOCIAL_ACCOUNT_SUCCESS,
  account,
});

export const startSetSocialAccount = data => dispatch =>
  webmaster.addSocialAccount(data).then(({ items }) => dispatch(setSocialAccount(items)));

export const setTourStep = (index, openMenu) => dispatch =>
  dispatch({
    type: webmasterConstants.SET_TOUR_STEP,
    index,
    openMenu,
  });

export const startUpdateNovicePopupAmount = amount => dispatch =>
  webmaster
    .updateNovicePopupAmount(amount)
    .then(({ items }) => dispatch(updateNovicePopupAmount(items[0])))
    .catch(() => dispatch({ type: webmasterConstants.SET_NOVICE_POPUP_AMOUNT_FAILURE }));

export const updateNovicePopupAmount = amount => dispatch =>
  dispatch({ type: webmasterConstants.SET_NOVICE_POPUP_AMOUNT_SUCCESS, amount });

export const setBotsInfo = bots => ({ type: webmasterConstants.SET_BOTS_INFO_SUCCESS, bots });

export const startSetBotsInfo = () => dispatch =>
  webmaster.getBots().then(({ items }) => dispatch(setBotsInfo(items)));

export const setTwoFactorAuth = ({ two_factor }) => {
  return {
    type: webmasterConstants.SET_TWO_FACTOR_AUTH,
    two_factor,
  };
};

export const startActivateTwoFactorAuth = type => dispatch =>
  webmaster.activateTwoFactorAuth(type).then(data => {
    return dispatch(setTwoFactorAuth(data));
  });

export const setJustRegisteredHasOffer = () => ({
  type: webmasterConstants.SET_JUST_REGISTERED_HAS_OFFER,
});

export const setJustRegisteredHasStream = () => ({
  type: webmasterConstants.SET_JUST_REGISTERED_HAS_STREAM,
});
